import { update_user_without_image, upload_user_image } from "./functions";

var user_firstName = "";
var user_lastName = "";
var user_username = "";
var user_age = "";
var user_gender = "";
var user_about = "";
var user_country = "";
var with_user_image = false;
var user_is_showFaved = false;

export {
  user_firstName,
  user_lastName,
  user_username,
  user_age,
  user_gender,
  user_about,
  user_country,
  with_user_image,
  user_is_showFaved,
};

export function revert_user_image() {
  with_user_image = false;
}

jQuery(document).ready(function ($) {
  if ($("#form__update__profile")) {
    //set new image when selecting one by the user
    $("#update-image").on("change", function () {
      //when selecting upload image by the user
      var file = $("#update-image")[0].files[0];

      if (file) {
        $("#upload-img").css("display", "none");
        $("#uploaded-user-img").attr("src", URL.createObjectURL(file));
        $("#uploaded-user-img").css("opacity", "1");
        with_user_image = true;
      } else {
        with_user_image = false;
        if (JSON.parse(localStorage.getItem("user_info"))?.photoURL) {
          $("#uploaded-user-img").attr(
            "src",
            JSON.parse(localStorage.getItem("user_info"))?.photoURL
          );
        } else {
          $("#upload-img").css("display", "inline-block");
          $("#uploaded-user-img").css("opacity", "0");
        }
      }
    });

    //update user info
    $("#form__update__profile").on("submit", function (e) {
      e.preventDefault();
      user_firstName = $("#update-first-name").val();
      user_lastName = $("#update-last-name").val();
      user_username = $("#update-user-name").val();
      user_age = $("#update-age").val();
      user_about = $("#update-about-me").val();
      user_gender = $("input[name='update-gender']:checked").val();
      user_country = $("#update-country").val();
      user_is_showFaved = $("#show_my_favorite_recipes").is(":checked");

      $("#edit_submit").addClass("button--loading");

      if (with_user_image) {
        var file = $("#update-image")[0].files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
          // use a regex to remove data url part
          const base64String = reader.result
            .replace("data:", "")
            .replace(/^.+,/, "");
          upload_user_image(base64String);
        };
        reader.readAsDataURL(file);
      } else {
        update_user_without_image(
          user_firstName,
          user_lastName,
          user_username,
          user_age,
          user_gender,
          user_about,
          user_country,
          user_is_showFaved
        );
      }
    });
  }
});
